const getNewWorker = () => {
  if (typeof Worker !== 'undefined') {
    const worker = new Worker(`${__ROOT__}/worker.transient.js`)
    if (!worker) console.warn('Worker is false', worker)
    return worker
  } else console.warn('Worker is undefined')
}

export default getNewWorker
